import { useState } from 'react'
import { Receipt, ArrowRight, Building2 } from 'lucide-react'
import { CommuneBilling } from './CommuneBilling'

type BillingView = 'hub' | 'commune'

export function BillingManagement() {
  const [currentView, setCurrentView] = useState<BillingView>('hub')

  if (currentView === 'commune') {
    return <CommuneBilling onBack={() => setCurrentView('hub')} />
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Facturation</h1>
        <p className="text-gray-600">Outils de facturation et suivi des paiements</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <button
          onClick={() => setCurrentView('commune')}
          className="group relative bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-left hover:shadow-md hover:border-teal-300 transition-all duration-200"
        >
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 bg-teal-50 rounded-lg flex items-center justify-center group-hover:bg-teal-100 transition-colors">
              <Building2 className="h-6 w-6 text-teal-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">Facturation aux communes</h3>
              <p className="text-sm text-gray-500">Calcul des montants a facturer aux communes pour les tarifs locaux et sociaux locaux.</p>
            </div>
          </div>
          <ArrowRight className="absolute top-8 right-6 h-5 w-5 text-gray-300 group-hover:text-teal-500 transition-colors" />
        </button>
      </div>
    </div>
  )
}
